import { useEffect, useRef, useState } from "react";
import axios from "axios";
import './SubmittedApplications.css'
import { useNavigate } from "react-router-dom";
import { format } from 'date-fns';
import { fetchSubmittedApplications } from "../../../services/complitedProfilesService";

const SubmittedApplications = () => {
  const [submitted, setSubmitted] = useState([]);
  const [selectedApp, setSelectedApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const userId = storedUser?.userId;
  let districtId = localStorage.getItem("districtId");
  districtId = districtId && districtId !== "null" ? Number(districtId) : null;

   let zoneId= localStorage.getItem("zoneId");
   zoneId= zoneId&& zoneId !="null"?Number(zoneId):null;
  const effectRan = useRef(false);

  useEffect(() => {
    const fetchSubmitted = async () => {
      setLoading(true);
      try {
        const data = await fetchSubmittedApplications(districtId,zoneId);
        // Sort by timestamp descending (latest first)
        const sorted = data.sort((a, b) => {
          const t1 = new Date(a.timestamp);
          const t2 = new Date(b.timestamp);
          return t2 - t1; // descending order
        });
        setSubmitted(sorted);
      } catch (err) {
        console.error("Failed to load submitted applications", err);
        setSubmitted([]);
      } finally {
        setLoading(false);
      }
    };

    if (effectRan.current === false) {
      fetchSubmitted();
    }
    return () => {
      effectRan.current = true;
    }

  }, []);


  const apmRoleNameGet = localStorage.getItem("role");

  const handleClick = (app) => {
    navigate("/checkList", { state: { application: app } });
  };

  return (
    <div>
      <div className="submitted-table">
        {/* Always show header */}
        <div className="submitted-header">
          {/* <div className="submitted-col">Draft Id</div> */}
          <div className="submitted-col">Full Name</div>
          <div className="table-col">District</div>
          <div className="submitted-col">Job Position</div>
          <div className="submitted-col">Submission Date and Time</div>
          <div className="submitted-col">Updated By</div>
          <div className="submitted-col">Status</div>
          {(apmRoleNameGet !== "APM" && apmRoleNameGet !== "PM" && apmRoleNameGet !== "APM Zone" && apmRoleNameGet !== 'APM OPERATIONS') && (
            <div className="submitted-col">Action </div>
          )}

        </div>

        {/* Conditional row rendering */}
        {loading ? (
          <div>Loading...</div>
        ) : submitted.length === 0 ? (
          <div className="no-records-message">No records available</div>
        ) : (
          submitted.map((app) => {
            const personalInfo = app.personalInformation;


            const formattedDateTime = app.timestamp
              ? format(new Date(app.timestamp), "dd-MM-yyyy , hh:mm a")
              : "—";

            return (
              <div key={personalInfo.id} className="submitted-row">
                <div className="submitted-col">{`${personalInfo.fullName || ""}`}</div>
                <div className="table-col">{app.district || "N/A"}</div>
                <div className="submitted-col">
                  {!app.personalInformation?.designation || app.personalInformation?.designation === "Not Assigned"
                    ? "N/A"
                    : app.personalInformation.designation}

                </div>
                <div className="submitted-col">{formattedDateTime}</div>
                <div className="submitted-col">{app.filledByName}</div>
                <div className="submitted-col">
                  {personalInfo.status
                    ? personalInfo.status.charAt(0).toUpperCase() +
                    personalInfo.status.slice(1).toLowerCase()
                    : "N/A"}
                </div>
                {(apmRoleNameGet !== "APM" && apmRoleNameGet !== "PM" && apmRoleNameGet !== "APM Zone" && apmRoleNameGet !== 'APM OPERATIONS') && (
                  <div className="submitted-col">
                    <button
                      className="submitted-view-button"
                      onClick={() => handleClick(app)}
                    >
                      Verification
                    </button>
                  </div>
                )}

              </div>
            );
          })
        )}

      </div>

    </div>
  );
};

export default SubmittedApplications;
